import React, { FC, Fragment } from 'react';
import { Trans } from 'react-i18next';
import { Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { EmptyState, Layouts } from 'components';

import { useInboxItems } from '../hooks';
import Notification from '../components/Notification';
import Loader from '../components/Loader';

import { NOTIFICATION_INBOX_LIMIT } from 'app-constants';

const Inbox: FC = () => {
  const { results, isEmpty, isExhausted, isInitialLoad, sentinelRef } = useInboxItems({
    limit: NOTIFICATION_INBOX_LIMIT,
  });
  const unreadCount = results.filter(item => !item.item_read).length;

  function renderMain() {
    if (isInitialLoad) {
      return <Loader rows={8} />;
    }

    if (isEmpty) {
      return <EmptyState name="notifications" />;
    }

    return (
      <Fragment>
        {results.map(item => (
          <Grid key={item.id}>
            <Notification size="large" item={item} />
          </Grid>
        ))}
        {!isExhausted && (
          <Grid ref={sentinelRef}>
            <Loader rows={1} />
          </Grid>
        )}
      </Fragment>
    );
  }

  function renderBody() {
    return (
      <Grid container alignItems="center" marginTop={4}>
        <Grid xs={12} container alignItems="center" justifyContent="space-between" marginBottom={2}>
          <Grid>
            <Typography color="inherit" variant="h4">
              <Trans i18nKey="common:notification_plural" />
            </Typography>
          </Grid>

          <Grid>
            <Typography color="inherit" variant="subtitle2">
              <Trans i18nKey="components:xNew" count={unreadCount} />
            </Typography>
          </Grid>
        </Grid>

        <Grid xs={12}>{renderMain()}</Grid>
      </Grid>
    );
  }

  return <Layouts.App1Column desktopSize={6} main={renderBody()} />;
};

export default Inbox;
